import customiz from './custom/customiz.js';
import tracking from './custom/tracking.js';

customiz();
tracking();